document.addEventListener("DOMContentLoaded", () => {
  class ModalElement extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({ mode: "open" });

      this.shadowRoot.innerHTML = `
        <style>
          :host {
            display: contents;
          }
          .backdrop {
            display: none;
            position: fixed;
            inset: 0;
            background: rgba(0,0,0,0.5);
            z-index: 12000;
            align-items: center;
            justify-content: center;
          }
          .backdrop.open {
            display: flex;
          }
          .modal-content {
            background: var(--color-background);
            max-width: 584px;
            overflow: auto;
            margin: 0 20px;
          }
        </style>
        <slot name="toggle"></slot>
        <div class="backdrop">
          <div class="modal-content">
            <slot name="content"></slot>
          </div>
        </div>
      `;
    }

    connectedCallback() {
      // Move the element to <body> so the fixed backdrop is not trapped by parent stacking contexts.
      if (this.parentElement !== document.body) {
        this._initialized = false;
        document.body.appendChild(this);
        return;
      }

      if (this._initialized) return;
      this._initialized = true;

      const content = this.querySelector("modal-content");
      const backdrop = this.shadowRoot.querySelector(".backdrop");

      // Close on backdrop click
      backdrop?.addEventListener("click", (e) => {
        if (e.target === backdrop) {
          backdrop.classList.remove("open");
        }
      });

      // Close button inside content
      const closeBtn = content?.querySelector(".close");
      closeBtn?.addEventListener("click", () => {
        backdrop.classList.remove("open");
      });

      // Listen for global open event
      const id = this.getAttribute("id");
      if (id) {
        window.addEventListener(`open-modal-${id}`, () => {
          backdrop.classList.add("open");
        });
      }
    }
  }

  customElements.define("modal-element", ModalElement);

  class ModalToggle extends HTMLElement {
    connectedCallback() {
      const modalId = this.getAttribute("modal-id");
      if (!modalId) return;

      this.addEventListener("click", () => {
        window.dispatchEvent(new Event(`open-modal-${modalId}`));
      });
    }
  }

  customElements.define("modal-toggle", ModalToggle);
});
